import React, { useState, useEffect } from 'react';
import { Menu, X, Phone } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { label: 'Início', href: '#inicio' },
    { label: 'Redundância', href: '#redundancia' },
    { label: 'Solução', href: '#solucao' },
    { label: 'Serviços', href: '#servicos' },
    { label: 'Contato', href: '#contato' }
  ];

  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md py-3' : 'bg-transparent py-4'
      }`}
    >
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center space-x-3">
            <img
              src={isScrolled 
                ? "https://www.tmctelecomunicacoes.com.br/site/wp-content/uploads/2026/06/logo-100px.png" 
                : "https://www.tmctelecomunicacoes.com.br/site/wp-content/uploads/2026/06/logo-branco-100px.png"
              }
              alt="TMC Telecomunicações"
              className="h-10 md:h-12 w-auto"
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-6">
            {navItems.map((item, index) => (
              <a
                key={index}
                href={item.href}
                onClick={(e) => scrollToSection(e, item.href)}
                className={`text-sm font-medium transition-colors hover:text-[#0079be] ${
                  isScrolled ? 'text-gray-700' : 'text-white'
                }`}
              >
                {item.label}
              </a>
            ))}
          </nav>

          {/* Phone & Mobile Menu Button */}
          <div className="flex items-center space-x-4">
            <a
              href="tel:+551198638-0017"
              className={`hidden md:flex items-center space-x-2 transition-colors ${
                isScrolled 
                  ? 'text-[#0079be] hover:text-[#005a8c]' 
                  : 'text-white hover:text-gray-200 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-lg border border-white/20'
              }`}
            >
              <Phone className="w-4 h-4" />
              <span className="text-sm font-semibold">(11) 98638-0017</span>
            </a>

            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="lg:hidden p-2"
              aria-label="Toggle menu"
            >
              {isMobileMenuOpen ? (
                <X className={isScrolled ? 'text-gray-900' : 'text-white'} />
              ) : (
                <Menu className={isScrolled ? 'text-gray-900' : 'text-white'} />
              )}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <nav className="lg:hidden mt-4 pb-4 space-y-2 animate-in fade-in slide-in-from-top-5 duration-300">
            {navItems.map((item, index) => (
              <a
                key={index}
                href={item.href}
                onClick={(e) => scrollToSection(e, item.href)}
                className="block py-2 px-4 text-sm font-medium text-gray-700 hover:bg-gray-100 rounded-lg transition-colors"
              >
                {item.label}
              </a>
            ))}
            <a
              href="tel:+551198638-0017"
              className="flex items-center space-x-2 py-2 px-4 text-sm font-medium text-[#0079be] hover:bg-gray-100 rounded-lg transition-colors"
            >
              <Phone className="w-4 h-4" />
              <span>(11) 98638-0017</span>
            </a>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;